"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import React from "react";
import _ from "underscore";
import R from "ramda";
import { Surface } from "react-art";
import Utils from "../../util/drawing_utils";
import AnnotationComponents from "./components";
import handleHover from "./highlight_on_hover";
import showDragPoints from "./show_drag_points";
import WaitingSpinner from "../../components/waiting_spinner";
const createComponentInfo = ({
  handlers,
  hover,
  selected,
  width,
  height,
  annotating,
  annotationStampUrl,
  cropping,
  page
}) => (component) => {
  const hovered = component.guid === hover.viewID;
  const isSelected = selected && component.guid === selected.guid;
  const hoveredDragPointIndex = hovered ? hover.dragPointIndex : null;
  return {
    guid: component.guid,
    AnnotationComponent: AnnotationComponents[component.typeID],
    props: R.merge(component, {
      handlers: handlers.component,
      hovered,
      selected: isSelected,
      canvasWidth: width,
      canvasHeight: height,
      hoveredDragPointIndex,
      annotating,
      cropping,
      page,
      annotationStampUrl
    })
  };
};
const createComponent = ({ AnnotationComponent, props, guid }) => {
  const Component = handleHover(AnnotationComponent);
  return /* @__PURE__ */ React.createElement(Component, __spreadProps(__spreadValues({}, props), { key: guid }));
};
const wrap = (wrapper) => ({ AnnotationComponent, props, guid }) => {
  const WrappedComponent = wrapper(AnnotationComponent);
  if (!WrappedComponent) {
    return void 0;
  }
  return /* @__PURE__ */ React.createElement(WrappedComponent, __spreadProps(__spreadValues({}, props), { key: guid }));
};
const AnnotationSurface = React.createClass({
  getDefaultProps() {
    return {
      annotationComponents: [],
      handlers: {
        loadAnnotations: () => {
        },
        deleteAnnotation: () => {
        },
        canvas: {
          onMouseDown: () => {
          },
          onMouseMove: () => {
          },
          onMouseUp: () => {
          },
          canvasSizeUpdated: () => {
          }
        }
      }
    };
  },
  deleteSelected(e) {
    if (_.contains([8, 46], e.keyCode) && this.props.annotating && this.props.selected && !this.props.editedTextAnnotation) {
      e.preventDefault();
      this.props.handlers.deleteAnnotation(this.props.selected.guid);
    }
  },
  componentDidMount() {
    this.props.handlers.canvas.canvasSizeUpdated(
      this.props.width,
      this.props.height
    );
    this.props.handlers.loadAnnotations(this.props.page);
    window.addEventListener("keydown", this.deleteSelected);
  },
  componentWillUnmount() {
    window.removeEventListener("keydown", this.deleteSelected);
  },
  componentWillReceiveProps(newProps) {
    if (this.props.width !== newProps.width || this.props.height !== newProps.height) {
      this.props.handlers.canvas.canvasSizeUpdated(
        newProps.width,
        newProps.height
      );
    }
    if (newProps.page.id !== this.props.page.id) {
      this.props.handlers.updateAnnotations(newProps.page);
    }
  },
  onMouse(event) {
    event.preventDefault();
    const coords = Utils.relMouseCoords(event, this.refs.annotation_canvas);
    const canvasRect = document.getElementsByClassName("document-browser__zoomable-container")[0].getBoundingClientRect();
    const handlers = this.props.handlers.canvas;
    switch (event.type) {
      case "mousedown":
      case "touchstart":
        handlers.onMouseDown(coords);
        break;
      case "mousemove":
      case "touchmove":
        handlers.onMouseMove(coords, canvasRect);
        break;
      case "mouseup":
      case "touchend":
        handlers.onMouseUp(coords);
        break;
      case "touchcancel":
        break;
      default:
        return;
    }
  },
  annotationComponents() {
    const comps = this.props.annotationComponents || [];
    return comps.sort((a, b) => {
      if (a.type === "Crop") {
        return 1;
      } else if (b.type === "Crop") {
        return -1;
      }
      return a.id - b.id;
    });
  },
  dragPoints(components) {
    if (this.props.annotating) {
      return components.map(wrap(showDragPoints));
    }
    return [];
  },
  render: function render() {
    const components = this.annotationComponents().map(
      createComponentInfo(this.props)
    );
    const annotationComponents = components.map(createComponent);
    const mouseHandler = this.props.annotating ? this.onMouse : void 0;
    const dragPoints = this.dragPoints(components);
    return /* @__PURE__ */ React.createElement(WaitingSpinner, { "data-component": "AnnotationSurface", when: this.props.loading }, /* @__PURE__ */ React.createElement(
      "div",
      {
        ref: "annotation_canvas",
        onMouseDown: mouseHandler,
        onMouseMove: mouseHandler,
        onMouseUp: mouseHandler,
        onTouchStart: mouseHandler,
        onTouchMove: mouseHandler,
        onTouchEnd: mouseHandler,
        onTouchCancel: mouseHandler,
        style: { padding: 0, margin: 0, border: 0 },
        className: this.props.loading ? "loading" : "loaded"
      },
      /* @__PURE__ */ React.createElement(Surface, { width: this.props.width, height: this.props.height }, annotationComponents, dragPoints)
    ));
  }
});
export default AnnotationSurface;
